// extracted by mini-css-extract-plugin
export default {"icon":"IconVibrance_icon__Yc8iL"};